import PropTypes from 'prop-types'
import React from 'react'
import FontAwesome from 'react-fontawesome'
import { connect } from 'react-redux'
import { StyledTable, StyledTableWrapper } from './table.style'

function stickyHeader() {
	const header = document.querySelector('header')
	if (!header) return

	const generatedClassName = '.' + this.generatedClassName

	const $table = document.querySelector(`${generatedClassName} table`)
	const $thead = document.querySelector(`${generatedClassName} thead`)

	const $ths = document.querySelectorAll(
		`${generatedClassName} thead > tr > th`
	)

	if (!$table) return
	const tableOffsetTop = $table.offsetTop

	const headerOffset = header.offsetHeight

	const beSticky = window.pageYOffset + headerOffset >= tableOffsetTop
	const stickyTop = window.pageYOffset + headerOffset - tableOffsetTop
	const maxTop = $table.clientHeight - $thead.clientHeight * 2

	$thead.style.top = beSticky ? Math.min(maxTop, stickyTop) + 'px' : '0'
	$thead.style['z-index'] = '0'

	const $tbodyThs = document.querySelectorAll(
		`${generatedClassName} tbody > tr:first-child > th`
	)
	if ($tbodyThs[0] == null) return

	let totalWidth = 0
	const avoidLineBreak = 1
	const tableWidth = $table.clientWidth - avoidLineBreak

	for (let index = 0; index < $ths.length; index++) {
		const nextWidth = $tbodyThs[index].clientWidth
		totalWidth += nextWidth

		if (totalWidth > tableWidth)
			$ths[index].style.width = nextWidth - (totalWidth - tableWidth) + 'px'
		else $ths[index].style.width = nextWidth + 'px'
	}
}

function assertArrayNotEqual(arr1, arr2) {
	return (
		arr1.length != arr2.length ||
		arr1.some((val, index) => val != arr2[index])
	)
}

class TableComponent extends React.Component {
	constructor(props) {
		super(props)
		this.generatedClassName = 'generatedClass' + ~~(Math.random() * 1000)
	}

	componentDidMount() {
		this.stickyFn = stickyHeader.bind(this)
		window.addEventListener('scroll', this.stickyFn)
		window.addEventListener('resize', this.stickyFn)
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.stickyFn)
		window.removeEventListener('resize', this.stickyFn)
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.privateMenuState !== nextProps.privateMenuState) {
			stickyHeader.call(this)
		}
	}

	componentDidUpdate() {
		stickyHeader.call(this)
	}

	shouldComponentUpdate(nextProps) {
		const { data, sidx, sord } = this.props
		return !!(
			nextProps.sidx != sidx ||
			nextProps.sord != sord ||
			(nextProps.data && assertArrayNotEqual(data, nextProps.data))
		)
	}

	render() {
		return (
			<StyledTableWrapper
				className={this.generatedClassName}
				ref={'wrapper'}>
				<StyledTable>
					<thead>{renderHeaders.call(this)}</thead>
					<tbody>
						{renderHeaders.call(this)}
						{renderRows.call(this)}
					</tbody>
				</StyledTable>
			</StyledTableWrapper>
		)
	}
}

function renderHeaders() {
	const { headers, onClickHeader, sidx, sord, sortable } = this.props
	return (
		<tr>
			{headers.map(({ header, key, align }) => {
				const isSortable =
					sortable && sortable.cols.some(col => col.key === key)
				return (
					<th
						key={key}
						align={align}
						className={`${isSortable ? 'sortable ' : ''}${
							align ? '' : 'left'
						}`}
						onClick={() =>
							isSortable && onClickHeader && onClickHeader(key)
						}>
						{typeof header === 'function' ? header() : header}
						{sidx === key && (
							<FontAwesome
								size={'lg'}
								name={sord === 'asc' ? 'angle-down' : 'angle-up'}
								style={{ marginLeft: '5px' }}
							/>
						)}
					</th>
				)
			})}
		</tr>
	)
}

function defaultRender(rowData, headers) {
	return headers.map(({ key, align }) => (
		<td key={key} align={align}>
			<span title={rowData[key]}>{rowData[key]}</span>
		</td>
	))
}

function renderRows() {
	const { data, renderRow, headers } = this.props
	return data.map((rowData, index) => (
		<tr key={index}>{(renderRow || defaultRender)(rowData, headers)}</tr>
	))
}

TableComponent.propTypes = {
	data: PropTypes.any,
	headers: PropTypes.arrayOf(
		PropTypes.shape({
			header: PropTypes.node.isRequired,
			key: PropTypes.string.isrequired
		})
	).isRequired,
	onClickHeader: PropTypes.func,
	renderRow: PropTypes.func,
	sidx: PropTypes.string,
	sord: PropTypes.string,
	sortable: PropTypes.shape({
		defaultOrder: PropTypes.string,
		cols: PropTypes.arrayOf(
			PropTypes.shape({
				key: PropTypes.string.isRequired,
				sortFn: PropTypes.func
			})
		)
	})
}

const mapStateToProps = ({ site }) => ({
	privateMenuState: site.privateMenuState
})

const Table = connect(mapStateToProps, null)(TableComponent)

export default Table
